import { Checkbox, DirectionalHint, TooltipHost } from '@fluentui/react';
import React from 'react';
import { IPFieldProps } from '../../types/field-props';
import CCheckBox from '../types/CCheckBox';

export const PCheckBox = (props: IPFieldProps<CCheckBox>): JSX.Element => {

    const field = props.field;
    const label = field.label;
    const disabled = field.disabled;
    const readonly = field.readonly;
    const checked = props.field.value as boolean || false;

    return <TooltipHost
        content={props.field.help}
        directionalHint={DirectionalHint.rightCenter}>
        <Checkbox
            label={label}
            disabled={disabled || readonly}
            checked={checked}
            onChange={(_: any, checked: boolean) => props.field.value = checked}
        />
    </TooltipHost>

}